import { render, staticRenderFns } from "./DetailsForm.vue?vue&type=template&id=558370de"
import script from "./DetailsForm.vue?vue&type=script&lang=js"
export * from "./DetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports